export default "__VITE_PUBLIC_ASSET__fd5bc0dc__"